var React = require('react');

function ChevronRight16px (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.86201 2.52859C5.12236 2.26824 5.54447 2.26824 5.80482 2.52859L11.1382 7.86193C11.3985 8.12228 11.3985 8.54439 11.1382 8.80474L5.80482 14.1381C5.54447 14.3984 5.12236 14.3984 4.86201 14.1381C4.60166 13.8777 4.60166 13.4556 4.86201 13.1953L9.72394 8.33333L4.86201 3.4714C4.60166 3.21105 4.60166 2.78894 4.86201 2.52859Z","fill":"#212121"}));
}

ChevronRight16px.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ChevronRight16px;

ChevronRight16px.default = ChevronRight16px;
